export enum PRIVATE_URIS {
  DASHBOARD = 'user/:username/dashboard',
  DIRECT_MESSAGES = 'user/:username/direct-messages',
  FEED = 'user/:username/feed',
  INTERESTS = 'user/:username/interests',
  POST = '/post/:postId',
  POSTS = '/user/:username/posts',
  PROFILE = 'user/:username/profile',
  DRAFT = '/draft/:draftId',
  POST_REPLY_DRAFT = '/post-reply-draft/:postReplyDraftId',
  DRAFTS = '/user/:username/drafts',
  REPLIES = 'user/:username/replies',
  REPLY = '/reply/:replyId',
  SETTINGS = 'user/:username/settings',
  STORIES = 'user/:username/stories',
  LIKES = 'user/:username/likes',
  BOOKMARKED = 'user/:username/bookmarked',
  SHARED = 'user/:username/shared',
  FOLLOWING = 'user/:username/following',
  SEARCH = '/search',
  CIRCLES = 'user/:username/circles',
  MODERATION_QUEUE = '/moderation/queue',
  POST_EDIT_REWRITE = '/post/:postId/edit-rewrite',
  POST_ANALYSIS = '/post/:postId/analysis',
  REPLY_ANALYSIS = '/reply/:replyId/analysis',
  POST_HISTORY = '/post/:postId/history',
  POST_SENTIMENT = '/post/:postId/sentiment',
  PULSE = '/pulse',
  REPUTATION = '/user/:username/reputation',
  VOUCH = '/vouch',
  README = '/readme',
  README_SECTION = '/readme/:slug',
}
